module.exports = __webpack_public_path__ + "media/images/country_flags/bm-b757e48169f71f6be9add4bf0e4e2f70.png";